import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall } from "../../../utils/request";
import * as sisenseConsts from "./constants";

export const state = {
  access_token: ""
};

export const getters = {
  [sisenseConsts.GETTERS_SISENSE_ACCESS_TOKEN]: state => {
    console.log("getters " + state.access_token);
    return state.access_token;
  }
};

export const actions = {
  [sisenseConsts.ACTION_GET_SISENSE_ACCESS_TOKEN]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      const detailUrl = getEndPoints().sisense.reports;
      makeCall(detailUrl, buildOptions("GET", {}), commit).then(
        response => {
          if (response.data) {
            commit(sisenseConsts.MUTATION_SET_SISENSE_ACCESS_TOKEN, response);
            resolve(response);
          }
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export const mutations = {
  [sisenseConsts.MUTATION_SET_SISENSE_ACCESS_TOKEN]: (state, sisense) => {
    //console.log("mutations " + sisense.data.access_token);
    //state.access_token = sisense.data.access_token;
    window.location.href =
      //process.env.SISENSE_SERVER_HOST + "jwt?jwt=" + state.access_token;
      process.env.SISENSE_SERVER_HOST;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/sisense/index.js